export type SizeUnit = 'Mb' | 'Gb'

type SizeOption = {
  value: number
  unit: SizeUnit
}

/**
 * Storage amount expressed in gigabytes into a display-friendly value/unit pair:
 * amounts below 1 GB are converted to megabytes (e.g. 0.5 -> { value: 500, unit: 'Mb' }),
 * everything else stays in gigabytes. The caller localizes the unit via i18n.
 * @param {number} gb storage amount in gigabytes
 * @returns {{ value: number, unit: SizeUnit }}
 */
export function getDataroomStorageSize (gb: number): { value: number, unit: SizeUnit } {
  const rounded = Number.parseFloat(Number(gb).toFixed(3))
  if (rounded > 0 && rounded < 1) {
    return { value: Math.round(rounded * 1000), unit: 'Mb' }
  }
  return { value: rounded, unit: 'Gb' }
}

export const PPU_DATAROOM_BASE_SIZE_OPTIONS: SizeOption[] = [
  { value: 500, unit: 'Mb' },
  { value: 1, unit: 'Gb' },
  { value: 2, unit: 'Gb' },
  { value: 5, unit: 'Gb' },
]

export const PPU_DATAROOM_ADDITIONAL_SIZE_OPTIONS: SizeOption[] = [
  { value: 10, unit: 'Gb' },
  { value: 15, unit: 'Gb' },
  { value: 20, unit: 'Gb' },
  { value: 25, unit: 'Gb' },
  { value: 30, unit: 'Gb' },
]
